var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMedicalwaste(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u56FE\\u5C42_1",
    "data-name": "\\u56FE\\u5C42 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#\u672A\u547D\u540D\u7684\u6E10\u53D8_9);}.cls-2{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "\\u672A\\u547D\\u540D\\u7684\\u6E10\\u53D8_9",
    x1: 32.01,
    y1: 62.59,
    x2: 31.99,
    y2: -1.43,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#e88143"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fea74a"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "z3_\u533B\u7597\u5E9F\u7269 ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 64,
    height: 64,
    rx: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.37,13.05a3.79,3.79,0,0,1,3.79,3.79V47.16a1.9,1.9,0,0,1,0,3.79H16.84a1.9,1.9,0,0,1,0-3.79V16.84a3.79,3.79,0,0,1,3.79-3.79H43.37ZM33.89,39.58H30.11a1.9,1.9,0,0,0-1.9,1.89h0v7.58h7.58V41.47a1.9,1.9,0,0,0-1.9-1.89ZM32,18.74a1.88,1.88,0,0,0-1.89,1.89h0v1.89h-1.9a1.88,1.88,0,0,0-1.88,1.67v.22a1.89,1.89,0,0,0,1.89,1.9H30.1v1.9a1.88,1.88,0,0,0,1.67,1.88l.22,0a1.89,1.89,0,0,0,1.89-1.9h0v-1.9h1.9a1.9,1.9,0,0,0,1.88-1.68v-.22a1.88,1.88,0,0,0-1.89-1.89h-1.9V20.63a1.88,1.88,0,0,0-1.67-1.88Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalwaste);
export default __webpack_public_path__ + "static/media/Medicalwaste.b37eccd3.svg";
export { ForwardRef as ReactComponent };